import axios from 'axios';
import {
  BOOKING_PUBLIC,
  BOOKING_VERIFY_FAILED_PUBLIC,
  BOOKING_VERIFY_PUBLIC,
  CREATE_PERSONE_MASETR_PUBLIC,
  CREATE_TRANSECTION_DUE_SLIP_PUBLIC,
  CREATE_TRANSECTION_SLIP,
  CREATE_TRANSECTION_SLIP_PUBLIC,
  DELETE_OTP_SLIP,
  DONATION_BILL_DETAILS,
  DONATION_BILL_DETAILS_PUBLIC,
  DONATION_BILL_LIST,
  DOWNLOAD_SLIP,
  SHOW_SLIP,
  TEMPLE_TRIST_DETAIL,
  UPDATE_STATUS_TRANSECTION_SLIP,
  UPDATE_TRANSECTION_SLIP,
  UPDATE_SLIP_FIELDS
} from '../../constant/API constant';

export const Donation_bill_Details = (paramObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DONATION_BILL_DETAILS}`, {
    headers: { Authorization: jwt_token },
    params: paramObj
  });
};
export const Donation_bill_Details_Public = (contactNoOrParamsObj, orgId, temple_uuid, eventUuid) => {
  const jwt_token = localStorage.getItem('token');
  let params = {};

  if (contactNoOrParamsObj && typeof contactNoOrParamsObj === 'object') {
    params = { ...contactNoOrParamsObj };
  } else {
    params = {
      mobile: contactNoOrParamsObj,
      orgId: orgId
    };
    if (temple_uuid) {
      params.temple_uuid = temple_uuid;
    }
    if (eventUuid) {
      params.eventUuid = eventUuid;
    }
  }

  // Clean undefined/null keys
  Object.keys(params).forEach((key) => {
    if (params[key] === undefined || params[key] === null) {
      delete params[key];
    }
  });

  return axios.get(`${process.env.REACT_APP_API_URL}${DONATION_BILL_DETAILS_PUBLIC}`, {
    headers: { Authorization: jwt_token },
    params
  });
};
export const Donation_bill_Details_personId_Public = (personId, orgId, temple_uuid) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DONATION_BILL_DETAILS_PUBLIC}`, {
    headers: { Authorization: jwt_token },
    params: {
      personId: personId,
      orgId: orgId
    }
  });
};

export const Donation_bill_List = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DONATION_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const CreateTrasectionSlip = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${CREATE_TRANSECTION_SLIP}`, formData, {
    headers: { Authorization: jwt_token }
  });
};

export const UpdateTrasectionSlip = (formData, slipId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${UPDATE_TRANSECTION_SLIP}/${slipId}`, formData, {
    headers: { Authorization: jwt_token }
  });
};
export const UpdateSlipFields = (formData, slipId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${UPDATE_SLIP_FIELDS}/${slipId}`, formData, {
    headers: { Authorization: jwt_token }
  });
};
export const UpdateTrasectionStatusSlip = (formData, slipId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${UPDATE_STATUS_TRANSECTION_SLIP}`, formData, {
    headers: { Authorization: jwt_token },
    params: { slipId }
  });
};
export const CreateTrasectionSlip_Public = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${CREATE_TRANSECTION_SLIP_PUBLIC}`, formData);
};
export const CreateTrasectionDueSlip_Public = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${CREATE_TRANSECTION_DUE_SLIP_PUBLIC}`, formData);
};
export const CreatePersoneMaster_Public = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${CREATE_PERSONE_MASETR_PUBLIC}`, formData);
};
export const RegisterPersoneEvent_Public = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/hisab-kitab/public/api/v1/personMaster/register`, formData);
};
export const UpdatePersoneMaster_Public = (formData, personId, token) => {
  return axios.put(`${process.env.REACT_APP_API_URL}${CREATE_PERSONE_MASETR_PUBLIC}`, formData, {
    headers: { Authorization: `Bearer ${token}` },
    params: { personId }
  });
};
export const UpdatePersoneMaster_Step_Two_Public = (formData, token) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${BOOKING_PUBLIC}`, formData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export const booking_verify_payment = (formData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${BOOKING_VERIFY_PUBLIC}`, formData);
};
export const booking_verify_payment_failed = (formData) => {
  return axios.put(`${process.env.REACT_APP_API_URL}${BOOKING_VERIFY_FAILED_PUBLIC}`, formData);
};
export const templeTrust_detail = (templeUuid, templeId) => {
  return axios.get(`${process.env.REACT_APP_API_URL}${TEMPLE_TRIST_DETAIL}`, {
    params: { templeUuid, templeId }
  });
};

export const Show_Slip = (slipId, isResent) => {
  const jwt_token = localStorage.getItem('token');
  let paramObj = {
    slipId
  };
  if (isResent) {
    paramObj['isResent'] = isResent;
  }
  return axios.get(`${process.env.REACT_APP_API_URL}${SHOW_SLIP}`, {
    headers: { Authorization: jwt_token },
    params: paramObj
  });
};
export const Download_Slip = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(
    `${process.env.REACT_APP_API_URL}${DOWNLOAD_SLIP}`,

    {
      headers: { Authorization: jwt_token },
      params: formData
    }
  );
};
export const generateOtp = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DELETE_OTP_SLIP}/${formData.slipId}`, {
    headers: { Authorization: jwt_token },
    params: formData
  });
};
